// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__6izEf","header":"Card_header__1hisz","headerText":"Card_headerText__3mC_G"};